import { Api } from "../contexts/api";
import Cookies from "universal-cookie";
import axios from "axios";
import { message } from "antd";

export async function LoginRequest(email: string, password: string, remember?: boolean) {
  axios.defaults.withCredentials = true;

  try {
    await Api.get("/sanctum/csrf-cookie");

    try {
      const { data } = await Api.post("/login", { email, password, remember });
      return data;
    } catch (error) {
      console.log(error)
    }
  } catch (error) {
    console.log(error);
    message.error("Não foi possível fazer login", 10);
  }
}

export function switchProfile() {
  localStorage.clear();
}

export function setUserLocal(user: any) {
  localStorage.setItem("user", JSON.stringify(user));

}

export function getUserLocal() {
  const json = localStorage.getItem("user");
  const parseJson = JSON.parse(json);

  if (!parseJson) return false;

  return parseJson ?? null;
}

export async function getSession() {
  try {
    await Api.get("/api/auth", {
      withCredentials: true,
      headers: {
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
      },
    });

    return true;
  } catch (error) {
    return false;
  }
}

export function setProfileLocal(profileData: any) {
  // cookies.set("profile", profileData, { maxAge: time });
  localStorage.setItem("profile", JSON.stringify(profileData));

}

export function getProfileLocal() {

  const profileLocal = localStorage.getItem("profile");

  if (!profileLocal) return false;

  const profile = JSON.parse(profileLocal);

  return profile ?? null;


}

const deleteAllCookies = () => {
  const cookies = document.cookie.split(";");

  for (const cookie of cookies) {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}


export async function clearCookies() {

  new Promise((resolve) => {
    resolve(
      setTimeout(() => {
        const cookies = new Cookies();

        const all = cookies.getAll();

        Object.keys(all).forEach((key) => {
          cookies.remove(`${key}`, {
            path: "/",
          });
        });

        deleteAllCookies()
      }, 500)
    );

    localStorage.clear();

  });

  return

}


export function getTheme() {
  const theme = localStorage.getItem("theme");
  return theme;
}

export function setTheme(theme: string) {
  localStorage.setItem("theme", theme);
}

export const default_image_src = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTvfGO04ytCwu_JIRF9PUaIdftleMULarFviN2q_EzX8TgBibRJmg05JDxj6TUcC_Zk8ag&usqp=CAU'

export const currencyParser = (val: any = '0') => {

  try {
    if (typeof val === "string" && !val.length) {
      val = "0.0";
    }

    let group = new Intl.NumberFormat("pt-BR").format(1111).replace(/1/g, "");
    let decimal = new Intl.NumberFormat("pt-BR").format(1.1).replace(/1/g, "");
    let reversedVal = val?.replace(new RegExp("\\" + group, "g"), "");

    reversedVal = reversedVal.replace(new RegExp("\\" + decimal, "g"), ".");
    reversedVal = reversedVal.replace(/[^0-9.]/g, "");

    const digitsAfterDecimalCount = (reversedVal.split(".")[1] || []).length;
    const needsDigitsAppended = digitsAfterDecimalCount > 2;

    if (needsDigitsAppended) {
      reversedVal = reversedVal * Math.pow(10, digitsAfterDecimalCount - 2);
    }
    return Number.isNaN(reversedVal) ? 0 : parseFloat(reversedVal);
  } catch (error) {
    console.error(error);
  }
};

export const currencyFormatter =
  (selectedCurrOpt: string) => (value: number | bigint) => {
    return new Intl.NumberFormat("pt-br", {
      style: "currency",
      currency: selectedCurrOpt.split("::")[1],
    }).format(value);
  };

export const setContent = async (url: string, set: (data: unknown) => void) => {
  try {
    const { data } = await Api.get(`/api/${url}`);
    set(data.data);
  } catch (error) {
    message.error("Não foi possível carregar os dados");
  }
  return;
};


export const recents = (list: any) => {


  const aux = list.filter((item: any) => {

    const itemDate = new Date(item.created_at)

    const itemMonth = itemDate.toLocaleString('default', { month: 'numeric' });
    const actualMonth = new Date().toLocaleString('default', { month: 'numeric' });


    // eslint-disable-next-line eqeqeq
    const isRecent = Number(itemMonth) == Number(actualMonth) - 1 || itemMonth == actualMonth

    return isRecent

  }).length


  return aux

}


export function cnpjValidation(value: any) {
  if (!value) return false;

  // Aceita receber o valor como string, número ou array com todos os dígitos
  const isString = typeof value === "string";
  const validTypes =
    isString || Number.isInteger(value) || Array.isArray(value);

  // Elimina valor em formato inválido
  if (!validTypes) return false;

  // Filtro inicial para entradas do tipo string
  if (isString) {
    // Limita ao máximo de 18 caracteres, para CNPJ formatado
    if (value.length > 18) return false;

    // Teste Regex para veificar se é uma string apenas dígitos válida
    const digitsOnly = /^\d{14}$/.test(value);
    // Teste Regex para verificar se é uma string formatada válida
    const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(value);

    // Se o formato é válido, usa um truque para seguir o fluxo da validação
    if (!(digitsOnly || validFormat)) return false;

  }

  // Guarda um array com todos os dígitos do valor
  const match = value.toString().match(/\d/g);
  const numbers = Array.isArray(match) ? match.map(Number) : [];

  // Valida a quantidade de dígitos
  if (numbers.length !== 14) return false;

  // Elimina inválidos com todos os dígitos iguais
  const items = [...new Set(numbers)];
  if (items.length === 1) return false;

  // Cálculo validador
  const calc = (x: number) => {
    const slice = numbers.slice(0, x);
    let factor = x - 7;
    let sum = 0;

    for (let i = x; i >= 1; i--) {
      const n = slice[x - i];
      sum += n * factor--;
      if (factor < 2) factor = 9;
    }

    const result = 11 - (sum % 11);

    return result > 9 ? 0 : result;
  };

  // Separa os 2 últimos dígitos de verificadores
  const digits = numbers.slice(12);

  // Valida 1o. dígito verificador
  const digit0 = calc(12);
  if (digit0 !== digits[0]) return false;

  // Valida 2o. dígito verificador
  const digit1 = calc(13);

  return digit1 === digits[1];
}


